import { CommunityId, MessageOptions } from "@sp-crm/core";
import { SelectPro } from "components/ui/select-pro";
import * as React from "react";

export const SelectCommunities = ({
    communities,
    message,
    updateSelectedCommunity,
}: {
    communities: { id: CommunityId; name: string }[];
    message: MessageOptions;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- eslintintroduction
    updateSelectedCommunity: (newValue: any) => void;
}): JSX.Element => {
    const options = React.useMemo(
        () =>
            (communities || [])
                .sort((a, b) => (a.name || "").localeCompare(b.name || ""))
                .map(community => {
                    return {
                        value: community.id,
                        text: community.name,
                    };
                }),
        [communities],
    );

    let initial = message.communityId || "";
    if (!initial && options.length > 0) {
        initial = options[0].value;
        updateSelectedCommunity(initial);
    }

    return (
        <SelectPro
            includePlaceholderOption={false}
            value={initial}
            options={options}
            onChange={e => updateSelectedCommunity(e.target.value)}
            label="Community"
        />
    );
};
